<template>
  <div class="modal" :class="{ 'is-active': shown }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"></p>
        <button class="btn spaceless isGray isCollapsed" @click="closeSelf()">
          <icon type="x" size="16"/>
        </button>
      </header>
      <section class="modal-card-body">
        <p>
          Opravdu chcete změnit jméno uživatele
          <strong>{{ confUsername }}</strong>?
        </p>
      </section>

      <footer class="modal-card-foot">
        <div class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <button class="btn spaceless isGreen" @click="confirm()">
                <icon type="check" size="16"/>Ano
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: ['shown', 'confUsername'],

  methods: {
    closeSelf() {
      this.$emit('closeSelf');
    },

    confirm() {
      this.$emit('confirmed');
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/buttons.sass'

.modal-card-title
  margin-bottom: 0 !important

.modal-card-foot .level
  width: 100%

.modal-card-body
  text-align: center

</style>
